<template>
  <v-select
    v-model="internalValue"
    :items="items"
    :label="label || 'Tipo de Cliente'"
    placeholder="Seleccione un Tipo"
    item-value="value"
    item-text="text"
    outlined
    dense
    :error-messages="errors"
    :disabled="disabled"
    @input="updateValue"
    @change="change"
    hide-details="auto"
  ></v-select>
</template>

<script>
import tipoCustomer from '@/utils/tipoCustomer.js'

export default {
  name: 'TipoSelection',
  props: {
    value: [String, Number, Object],
    errors: {
      type: [Array, String],
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    filtro: {
      type: Boolean,
      default: true
    },
    label: String
  },
  data: () => ({
    items: [],
    internalValue: null
  }),
  watch: {
    value: {
      handler(newVal) {
        // Manejamos si llega un objeto o un valor simple
        this.internalValue = (newVal && typeof newVal === 'object') ? newVal.value : newVal
      },
      immediate: true
    }
  },
  methods: {
    updateValue(val) {
      this.$emit('input', val)
    },
    change(val) {
      this.$emit('change', val)
    }
  },
  mounted() {
    if (this.filtro) {
      this.items = [{ text: 'Todos los tipos', value: '' }, ...tipoCustomer]
    } else {
      this.items = tipoCustomer
    }
  }
}
</script>